import * as t from "io-ts";
import { withFallback } from "io-ts-types";
import { createCargoViewTypes, nullable } from "./index";
import optional from "./optional";
import isoDateTimeForJSON from "./isoDateTimeForJSON";
import { weekdaysT } from "./weekday";
export const timeInAdvanceUnitT = t.union([
    t.literal("week"),
    t.literal("day"),
]);
export const repeatEveryOptionT = t.union([
    t.literal("WEEK"),
    t.literal("OTHER_WEEK"),
    t.literal("THIRD_WEEK"),
    t.literal("EVERY_N_WEEKS"),
    t.literal("EVEN_WEEK"),
    t.literal("UNEVEN_WEEK"),
    t.literal("FIRST_WEEK_OF_THE_MONTH"),
    t.literal("SECOND_WEEK_OF_THE_MONTH"),
    t.literal("THIRD_WEEK_OF_THE_MONTH"),
    t.literal("FOURTH_WEEK_OF_THE_MONTH"),
    t.literal("SECOND_TO_LAST_WEEK_OF_THE_MONTH"),
    t.literal("LAST_WEEK_OF_THE_MONTH"),
]);
export const repeatEveryOptions = repeatEveryOptionT.types.map((c) => c.value);
export const repeatEveryOptionFirstWeekDefinitionT = t.union([
    t.literal("FIRST_TO_SEVENTH_OF_MONTH"),
    t.literal("FIRST_MONTH_WEEK_WITH_AT_LEAST_4_DAYS"),
    t.literal("FIRST_MONDAY_TO_FIST_SUNDAY_OF_MONTH"),
]);
export const repeatEveryOptionFirstWeekDefinitionOptions = repeatEveryOptionFirstWeekDefinitionT.types.map((c) => c.value);
const automaticCargoCreationScheduleEndOnDateTypeT = t.literal("END_ON_DATE");
const automaticCargoCreationScheduleEndOnDateT = t.strict({
    type: automaticCargoCreationScheduleEndOnDateTypeT,
    date: t.string,
});
export const automaticCargoCreationScheduleEndOnT = automaticCargoCreationScheduleEndOnDateT;
export const automaticCargoCreationScheduleRequestBodyT = t.strict({
    name: t.string,
    weekdays: weekdaysT,
    timeInAdvanceAmount: t.number,
    timeInAdvanceUnit: timeInAdvanceUnitT,
    skipFrom: nullable(t.string),
    skipTo: nullable(t.string),
    endOn: nullable(automaticCargoCreationScheduleEndOnT),
    repeatEveryOption: repeatEveryOptionT,
    repeatEveryPivotDate: nullable(t.string),
    repeatEveryNumberOfWeeks: nullable(t.number),
    repeatEveryOptionFirstWeekDefinition: repeatEveryOptionFirstWeekDefinitionT,
});
export const automaticCargoCreationScheduleFullRequestBodyT = t.strict({
    name: t.string,
    orgId: t.string,
    weekdays: weekdaysT,
    timeInAdvanceAmount: t.number,
    timeInAdvanceUnit: timeInAdvanceUnitT,
    unassignedCargoTemplatesNames: t.array(t.string),
    skipFrom: nullable(t.string),
    skipTo: nullable(t.string),
    routeTemplates: t.array(t.strict({
        name: optional(t.string),
        routeName: nullable(t.string),
        driverIds: t.array(t.string),
        truckId: nullable(t.string),
        cargoTemplates: t.array(t.strict({ cargoTemplateName: t.string })),
    })),
    endOn: nullable(automaticCargoCreationScheduleEndOnT),
    repeatEveryOption: repeatEveryOptionT,
    repeatEveryPivotDate: nullable(t.string),
    repeatEveryNumberOfWeeks: nullable(t.number),
    repeatEveryOptionFirstWeekDefinition: repeatEveryOptionFirstWeekDefinitionT,
});
export const createScheduleCargoTemplateTypes = ({ decimal, dateTime, }) => {
    const { cargoViewsT } = createCargoViewTypes({ decimal, dateTime });
    const routeTemplateBaseT = t.strict({
        routeName: nullable(t.string),
        driverIds: t.array(t.string),
        truckId: nullable(t.string),
        unpoweredTrailerId: nullable(t.string),
        cargoTemplates: cargoViewsT,
    });
    const routeTemplateWithIdT = t.intersection([
        routeTemplateBaseT,
        t.strict({
            name: t.string,
            teamId: withFallback(nullable(t.string), null),
            waypointNote: nullable(t.string),
            hasCargos: t.boolean,
            firstStop: nullable(t.strict({
                city: nullable(t.string),
            })),
            lastStop: nullable(t.strict({
                city: nullable(t.string),
            })),
            createdAt: isoDateTimeForJSON,
            updatedAt: isoDateTimeForJSON,
        }),
    ]);
    const automaticCargoCreationScheduleWithDataT = t.strict({
        id: t.string,
        name: t.string,
        orgId: t.string,
        weekdays: weekdaysT,
        timeInAdvanceAmount: t.number,
        timeInAdvanceUnit: timeInAdvanceUnitT,
        unassignedCargoTemplates: cargoViewsT,
        routeTemplates: t.array(routeTemplateWithIdT),
        updatedBy: nullable(t.string),
        updatedAt: isoDateTimeForJSON,
        skipFrom: nullable(t.string),
        skipTo: nullable(t.string),
        endOn: nullable(automaticCargoCreationScheduleEndOnT),
        repeatEveryOption: repeatEveryOptionT,
        repeatEveryPivotDate: nullable(t.string),
        repeatEveryNumberOfWeeks: nullable(t.number),
        repeatEveryOptionFirstWeekDefinition: repeatEveryOptionFirstWeekDefinitionT,
    });
    return { automaticCargoCreationScheduleWithDataT, routeTemplateWithIdT };
};
export const automaticCargoCreationScheduleT = t.intersection([
    automaticCargoCreationScheduleFullRequestBodyT,
    t.strict({
        id: t.string,
        updatedBy: nullable(t.string),
        updatedAt: isoDateTimeForJSON,
        searchableText: t.string,
    }),
]);
export const automaticCargoCreationSchedulesT = t.array(automaticCargoCreationScheduleT);
//# sourceMappingURL=automatic-cargo-creation-schedule.js.map